module.exports = __webpack_public_path__ + "static/media/Home.5769fc01.svg";